import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  bannerContainer: {
    backgroundColor: theme.palette.warning.main,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    color: theme.palette.common.white,
  }
}));

export default useStyles;
